import React from "react";

/** Google G in cyan-tinted dark theme. */
export const GoogleGIcon = ({ className = "w-4 h-4" }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="#FFC107"
            d="M21.805 10.041H21V10H12v4h5.651c-.823 2.327-3.04 4-5.651 4-3.314 0-6-2.686-6-6s2.686-6 6-6c1.527 0 2.92.575 3.972 1.515l2.832-2.832C17.046 2.99 14.62 2 12 2 6.478 2 2 6.478 2 12s4.478 10 10 10c5.523 0 10-4.478 10-10 0-.671-.069-1.325-.195-1.959z"
        />
        <path
            fill="#FF3D00"
            d="M3.153 7.345l3.288 2.41C7.323 7.554 9.485 6 12 6c1.527 0 2.92.575 3.972 1.515l2.832-2.832C17.046 2.99 14.62 2 12 2 8.137 2 4.795 4.156 3.153 7.345z"
        />
        <path
            fill="#4CAF50"
            d="M12 22c2.583 0 4.97-.99 6.78-2.604l-3.13-2.65C14.55 17.5 13.34 18 12 18c-2.604 0-4.812-1.665-5.642-3.987l-3.262 2.514C4.732 19.823 8.073 22 12 22z"
        />
        <path
            fill="#1976D2"
            d="M21.805 10.041H21V10H12v4h5.651c-.394 1.116-1.104 2.082-2.024 2.776l3.13 2.65C20.97 17.7 22 14.99 22 12c0-.671-.069-1.325-.195-1.959z"
        />
    </svg>
);

export default GoogleGIcon;
